export default "__VITE_ASSET__CWiO1AuO__"